import {connect} from 'react-redux'
import CheckCustomerView from '../components/CheckCustomerView'
import _ from 'lodash'
import {B} from '../../../../helpers'
import {changeStep} from "../../../../layouts/Content/modules/step";
import {appSetVal, appSetObj, appSetServerVal, checkFields, appCall} from '../../../../store/application'
import {updateAmounts, scanImages, resetCheckResult, resetCheckUploading, createTransaction} from "../modules/checkcashing";
import {resetScannerResult} from "../../../Devices/Scanner/modules/scanner";

const mapDispatchToProps = {
  updateAmounts: updateAmounts,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  appSetServerVal: appSetServerVal,
  changeStep: changeStep,
  checkFields: checkFields,
  appCall: appCall,
  resetScannerResult: resetScannerResult,
  scanImages: scanImages,
  resetCheckResult: resetCheckResult,
  resetCheckUploading: resetCheckUploading,
  createTransaction: createTransaction
};

const mapStateToProps = (state) => {
  const {
    s_customer_id,
    s_customer_check_path_front,
    s_customer_check_path_back,
    check_maker_aba_number,
    check_maker_account_number,
    check_number,
    check_date,
    check_images_processing,
    image_file_path_back,
    image_file_path_front,
    image_path_front,
    image_path_back,
    check_processing_done,
    check_processing_success,
    check_maker_name,
    check_maker_address,
    check_maker_city,
    check_maker_state,
    check_maker_zip,
    check_amount,
    check_raw_micr,
    check_payee_name,
    customer_amount,
    fee,
    updating_amounts
  } = state.app.x_data;

  const {imageFront, imageBack} = state.scanner;
  const { customer_id } = state.customer;

  const imagesIsReady = B(imageFront && imageBack);

  return {
    scanner_image_front: imageFront,
    scanner_image_back: imageBack,
    scanned_image_front: image_path_front || imageFront,
    scanned_image_back: image_path_back || imageBack,
    not_ready_to_recognize: check_images_processing || !imagesIsReady,
    check_maker_aba_number,
    check_maker_account_number,
    check_number,
    check_date,
    image_file_path_back,
    image_file_path_front,
    check_images_processing,
    check_processing_done,
    check_processing_success,
    check_maker_name,
    check_maker_address,
    check_maker_city,
    check_maker_state,
    check_maker_zip,
    check_amount,
    check_raw_micr,
    check_payee_name,
    customer_id,
    s_customer_id,
    s_customer_check_path_front,
    s_customer_check_path_back,
    customer_amount,
    fee,
    updating_amounts
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckCustomerView)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CheckCustomerContainer.js